/* eslint-disable no-undef */
import { StadiumFanAnalytics, AnalyticsInput } from '../../../types/inVenue';
import useAnalytics from './useAnalytics';

const useGenderBreakdown = ({
    rightsholder,
    season,
    clientId,
    gameDates,
    sectionIds,
}: Omit<AnalyticsInput, 'groupBy'>) => {
    const { data: analytics, isLoading } = useAnalytics({
        clientId,
        rightsholder,
        season,
        gameDates,
        sectionIds,
        groupBy: ['gender'],
    });

    const genderBreakdown = (analytics || []).reduce(
        (acc: any, curr: StadiumFanAnalytics) => {
            acc.total += curr.fanCount;
            acc.capacity += curr.capacityNormalizedFanCount;
            acc[curr.gender.toLowerCase()] = curr.fanCount;
            return acc;
        },
        {
            total: 0,
            capacity: 0,
            female: 0,
            male: 0,
        },
    );

    return { data: genderBreakdown, isLoading };
};

export default useGenderBreakdown;
